// #ifdef MP-WEIXIN
var baseUrl = "https://api.bgbgsc.com/api"
// var baseUrl = "https://test-api.bgbgsc.com/api"
// var baseUrl = "http://192.168.1.104:7777"
// var baseUrl = "http://f3c83656.natappfree.cc"
// #endif
// #ifdef H5
var baseUrl = "https://h5.bgbgsc.com/api"
// var baseUrl = "https://test-h5.bgbgsc.com/api"
// var baseUrl = "http://192.168.1.104:7777"
// #endif
export default baseUrl